import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import { Button } from '../../../components/forms/Buttons/Button';
import Select from '../../../components/forms/Select/Select';
import useSnackbar from '../../../utils/hooks/useSnackbar';
import { bulkUpdateSchoolYears } from '../../../services/catalog/schools';

// Adds or removes years on every school ticked in the table.
// The schools' other years stay as they are.
export default function SchoolYearsBulkActions({ selectedSchools, setSelectedSchools, yearList, onDone }) {
  const { addSnackbar } = useSnackbar();
  const [years, setYears] = useState([]);
  const [pendingMode, setPendingMode] = useState(null);

  const count = selectedSchools?.length ?? 0;
  const disabled = !count || !years.length || !!pendingMode;

  const apply = (mode) => {
    setPendingMode(mode);
    bulkUpdateSchoolYears({ schools: selectedSchools, years, mode })
      .then((res) => {
        addSnackbar(`Обновлено школ: ${res.schools}`, 'success');
        onDone();
      })
      .catch((err) => {
        // DRF answers {detail: '...'} or {field: ['...']}; anything else gets the generic text
        const data = err?.response?.data;
        const message =
          data && typeof data === 'object'
            ? data.detail || Object.values(data).flat().join(' ')
            : '';
        addSnackbar(message || 'Не удалось обновить годы', 'error');
      })
      .finally(() => setPendingMode(null));
  };

  return (
    <div className='mb-4 flex flex-row flex-wrap items-end gap-4 rounded-md border border-gray-200 p-4'>
      <Select
        className='w-72'
        label='Годы для выбранных школ'
        isMulti
        isSearchable={false}
        closeMenuOnSelect={false}
        value={years}
        options={yearList.map((y) => ({ value: y.uuid, label: y.year }))}
        onChange={(v) => setYears(v?.map((o) => o.value) ?? [])}
      />
      <Button
        text='Добавить'
        Icon={PlusIcon}
        color='primary'
        disabled={disabled}
        loading={pendingMode === 'add'}
        onClick={() => apply('add')}
      />
      <Button
        text='Убрать'
        Icon={MinusIcon}
        color='error'
        disabled={disabled}
        loading={pendingMode === 'remove'}
        onClick={() => apply('remove')}
      />
      <span className='flex h-10 items-center text-sm text-gray-500'>
        {count ? (
          <>
            Выбрано школ: {count}
            <button
              type='button'
              className='ml-2 text-blue-600 hover:underline'
              onClick={() => setSelectedSchools([])}
            >
              снять выбор
            </button>
          </>
        ) : (
          'Отметьте школы в таблице'
        )}
      </span>
    </div>
  );
}
